// import axios from "axios";
// import { BASE_URL, SUB_URL_dispatch_center } from "../BaseUrl";

// const ManageBinService ={

//     getBinDatabyBinId : async (bin_id) => {
//       try {
//         const formValue = new FormData();
//         formValue.append('bin_id', bin_id);

//         const response = await axios.post(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL_dispatch_center.getBinByBinId}`, formValue);        
//         return response.data;
//       } catch (error) {
//         console.error(error);
//       }  
//     },

//     BulkOutward : async (bin_ids, added_by) => {
//       console.log("BulkOutward", JSON.stringify(bin_ids), added_by);
      
//         try {
//             const formValue = new FormData();
//             formValue.append('bin_ids', JSON.stringify(bin_ids));
//             formValue.append('added_by', added_by);

//             for (let pair of formValue.entries()) {
//               console.log(`${pair[0]}: ${pair[1]}`);
//           }

//             const response = await axios.post(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL_dispatch_center.bin_bulk_outward}`, formValue);
//             console.log(response.data);
//             return response.data;
//         } catch (error) {
//             console.error("Failed to bulk outward",error);
            
//         }
//     },
//     getBulkBinData : async (bin_ids) => {
//       console.log("get bin Outward data", bin_ids);
      
//         try {
//             const formValue = new FormData();
//             formValue.append('bin_id', JSON.stringify(bin_ids));

//             const response = await axios.post(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL_dispatch_center.getBulkBindata}`, formValue);
//             return response.data;
//         } catch (error) {
//             console.error("Failed to bulk outward",error);
            
//         }
//     }
// };

// export default ManageBinService;

import axios from "axios";
import {
  getUnitApiBaseFour,
  SUB_URL,
  SUB_URL_dispatch_center,
} from "../BaseUrl";

const getUnitCode = () => {
  const unitCode = localStorage.getItem("unit_code");
  if (!unitCode) {
    throw new Error("unit_code missing");
  }
  return unitCode;
};

const ManageBinService = {
  getBinDatabyBinId: async (bin_id) => {
    try {
      const unitCode = getUnitCode();

      const formValue = new FormData();
      formValue.append("bin_id", bin_id || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL_dispatch_center.getBinByBinId}`,
        formValue,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Failed to get bin data by bin id:", error);
      return { status: false, data: [] };
    }
  },

  BulkOutward: async (bin_ids, added_by) => {
    try {
      const unitCode = getUnitCode();

      const formValue = new FormData();
      formValue.append("bin_ids", JSON.stringify(bin_ids || []));
      formValue.append("added_by", added_by || "");
      formValue.append("from_location", "dispatch_center");
      formValue.append("to_location", "washing");
      formValue.append("api_type", "outward");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.bulk_bin_movement}`,
        formValue,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Failed to bulk outward:", error);
      return { status: false };
    }
  },

  getBulkBinData: async (bin_ids) => {
    try {
      const unitCode = getUnitCode();

      const formValue = new FormData();
      formValue.append("bin_id", JSON.stringify(bin_ids || []));

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL_dispatch_center.getBulkBindata}`,
        formValue,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Failed to get bulk bin data:", error);
      return { status: false, data: [] };
    }
  },

  BulkInward: async (bin_ids, added_by) => {
    try {
      const unitCode = getUnitCode();

      const formValue = new FormData();
      formValue.append("bin_ids", JSON.stringify(bin_ids || []));
      formValue.append("received_by", added_by || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.garment_supermarket_bulk_inward}`,
        formValue,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Failed to bulk inward:", error);
      return { status: false };
    }
  },
};

export default ManageBinService;